import { render, staticRenderFns } from "./QrCodeLogsPage.vue?vue&type=template&id=447f32f4&lang=pug&"
import script from "./QrCodeLogsPage.vue?vue&type=script&lang=js&"
export * from "./QrCodeLogsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
